import { View } from 'react-native';
import TextLato from '../../../../../text/text-lato/TextLato';
import { styleDesktop, styleMobile } from '../StepCard.style';
import Button from '../../../../../buttons/button/Button';
import { Image } from 'expo-image';
import { FocusGroups } from '../../../../../focus-provider/FocusProvider.constants';
import { observer } from 'mobx-react-lite';
import { TestIDs } from 'src/constants/testIDs.constants';
import { useStore } from 'src/contexts/StoreContext';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { brand, neutrals } from 'src/theme/colors';
import { CardProps } from '../../ModalConfigurationSteps.types';
import { DEFAULT_SUGGESTED_BAND } from '../../ModalConfigurationSteps.constants';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { BandInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';

export const BandCard = observer(
  ({ item: band, index, isSelected, onPress, onFocus, productGroup }: CardProps<BandInfo>) => {
    const { i18n } = useStore();
    const isSuggested = band.code === DEFAULT_SUGGESTED_BAND;
    const { isDesktop } = useResponsiveScreen();
    const style = isDesktop ? styleDesktop : styleMobile;

    return (
      <Button
        onFocus={onFocus}
        onPress={async () => onPress(band)}
        testID={modalTestID(TestIDs.CONFIGURATION_STEPS, index.toString())}
        focusId={modalTestID(TestIDs.CONFIGURATION_STEPS, index.toString())}
        focusGroup={FocusGroups.MODAL}
        focusOrder={index}
      >
        {({ focused }) => {
          return (
            <View style={[style.border, isSelected ? style.borderSelected : focused ? style.borderFocus : undefined]}>
              <View style={[style.card, isDesktop && { height: 355 }]}>
                {isSuggested && (
                  <View style={style.badge}>
                    <View style={[style.icon, { padding: 2 }]}>
                      <Icon name={ICON_NAMES.Star} color={neutrals.white} filled />
                    </View>
                    <TextLato style={style.textBadge}>{i18n.t('modal-configuration-steps:best-seller')}</TextLato>
                  </View>
                )}
                <Image style={style.image} source={`/images/bands/${band.code}.png`} />
                <View style={style.textContainer}>
                  <TextLato style={style.textTitle}>{i18n.t(`modal-configuration-steps:band:${band.code}`)}</TextLato>
                  <View style={style.description}>
                    <TextLato
                      style={[style.textDescription, isSelected && { color: brand.main.water }]}
                      numberOfLines={4}
                    >
                      {i18n.t('modal-configuration-steps:bands-content:available-formats')}:{' '}
                      {band.formats
                        .map(format => i18n.t(`modal-configuration-steps:format:${format.split('.')[0]}`))
                        .join(', ')}
                    </TextLato>
                  </View>
                  {/* <TextLato style={style.textPrice}>
                  {i18n.t(`modal-configuration-steps:bands-price:${productGroup}:${band.code}`)}
                </TextLato> */}
                </View>
                {isDesktop && (
                  <View style={[style.radioButton, isSelected && { borderColor: brand.main.water }]}>
                    {isSelected && <View style={style.radioButtonSelected} />}
                  </View>
                )}
              </View>
            </View>
          );
        }}
      </Button>
    );
  },
);
